export default __webpack_public_path__ + "82818969a3defc45cf805117aa97bf2b.svg";